import React from "react";
import {connect} from 'dva';
import { message } from 'antd';
import moment from 'moment';
import './index.less';
import WrappedCustomField from '../../../components/fieldForms';
import {getCache} from "../../../utils/cache";

function PcForm(props) {

    const {ids, item, fieldConfig, LOCALE_HTML, cusParamsField, ticketTypeList, dispatch} = props;
    const myRef = React.createRef();
    const searchPath = (id, arr) => {
        if (!id) return {}
        for (const i of arr) {
            if (i.typeId === id) {
                return {
                    typePathName: i.typePathName ? i.typePathName : i.typeName,
                    typePathId: i.typePathId ? i.typePathId : i.typeId,
                }
            }
            if (i.items && i.items.length) {
                const obj = searchPath(id, i.items)
                if (obj) return obj
            }
        }
    }
    const handle = () => {
        let msgPhone =  ''; // 手机账号
        let msgCode = ''; // 手机验证码
        let msgNewCode = ''; // 新手机验证码
        let msgNewPhone = ''; // 更改手机验证码
        const formRef = myRef.current;
        formRef.validateFields((err, values) => {
            if (err) return;
            fieldConfig.forEach(obj => {
                const item = obj.cusFieldConfig;
                const itemVal = obj.cusFieldDataInfoList;
                if (item.fieldType === 6 || item.fieldType === 7 || item.fieldType === 8) {
                    values.extendFields.forEach(ext => {
                        if (ext.id === item.fieldId && ext.value) {
                            const val = itemVal.filter(i => i.dataValue === ext.value || ext.value.includes(i.dataValue)).map(j => j.dataName)
                            ext.text = val.join(',');
                        }
                    });
                }
                if(item.fieldName === '手机账号') {
                    values.extendFields.forEach(ext => {
                        if (ext.id === item.fieldId) {
                            msgPhone = ext.value;
                        }
                    });
                }
                if(item.fieldName === '更改为手机号') {
                    values.extendFields.forEach(ext => {
                        if (ext.id === item.fieldId) {
                            msgNewPhone = ext.value;
                        }
                    });
                }
                if(item.fieldName === '新手机验证码') {
                    values.extendFields.forEach(ext => {
                        if (ext.id === item.fieldId) {
                            msgNewCode = ext.value;
                        }
                    });
                }
                if(item.fieldName === '手机验证码') {
                    values.extendFields.forEach(ext => {
                        if (ext.id === item.fieldId) {
                            msgCode = ext.value
                        }
                    });
                }
                if (item.fieldType === 3) {
                    values.extendFields.forEach(ext => {
                        if (ext.id === item.fieldId && ext.value) {
                            ext.value = moment(ext.value).format('YYYY-MM-DD');
                        }
                    });
                }
                if (item.fieldType === 4) {
                    values.extendFields.forEach(ext => {
                        if (ext.id === item.fieldId && ext.value) {
                            ext.value = moment(ext.value).format('HH:mm');
                        }
                    });
                }
                if (item.fieldType === 7) {
                    values.extendFields.forEach(ext => {
                        if (ext.id === item.fieldId && ext.value) {
                            ext.value = ext.value.join(',');
                        }
                    });
                }
            });
            if (values.fileStr && values.fileStr.length > 0) {
                values.fileStr = values.fileStr.map(item => item.url).join(';');
            }
            let paramsExtends = ""
            if (cusParamsField.length > 0) {
                paramsExtends = JSON.stringify(cusParamsField.map(i => {
                    return {
                        id: i.id,
                        value: i.value,
                        params: i.params
                    }
                }))
            }
            const {typePathName = '', typePathId = ''} = searchPath(item.ticketTypeId, ticketTypeList) || {}
            let obj = {
                uid: ids.uid,
                companyId: ids.companyId,
                ticketContent: '',
                customerEmail: '',
                customerPhone: '',
                ticketFrom: 0,
                customerSource: 0,
                fileStr: '',
                extendFields: [],
                paramsExtends,
                ticketTypeId: item.ticketTypeFlag === 1 ? values.ticketTypeId : item.ticketTypeId,
                ticketTypeNamePath: item.ticketTypeFlag === 1 ? getCache("typePathName") : typePathName,
                ticketTypeIdPath: item.ticketTypeFlag === 1 ? getCache("typePathId") : typePathId,
                templateId: item.templateId,
                token: decodeURIComponent(window.urlObject.token) || '',
            };
            values.extendFields = JSON.stringify(values.extendFields);
            const data = {...obj, ...values, msgPhone, msgCode, msgNewPhone, msgNewCode};
            dispatch({
                type: 'app/postMsg',
                payload: {
                    data
                },
                callback: function (msg) {
                    if(msg.retCode === "000000"){
                        dispatch({
                            type: 'app/changeItem',
                            payload: 2
                        });
                        dispatch({
                            type: 'app/update',
                            payload: {
                                sbumitFlag:false
                            }
                        });
                        formRef.resetFields();
                    } else {
                        message.warn(msg.retMsg, 2);
                    }
                }
            });
        });
    };

    return (
        <div>
            <div className="pc-form-wrap">
                <div className="top-tip-txt" dangerouslySetInnerHTML={{__html: item.msgTxt}}/>
                <WrappedCustomField {...props} ref={myRef}/>
            </div>

            <div className="btn-wrap">
                <div className="submit-btn" onClick={handle}>{LOCALE_HTML['submit']}</div>
            </div>
        </div>
    )
}

const mapState = state => {
    const {ids, item, fieldConfig, ticketTypeList, sbumitFlag, cusParamsField} = state.app;
    const {LOCALE_HTML} = state.locale;
    return {
        ids,
        item,
        fieldConfig,
        ticketTypeList,
        sbumitFlag,
        cusParamsField,
        LOCALE_HTML
    };
};

export default connect(mapState)(PcForm);
